import { z } from "zod";

export const wordForms = z.object({
  singular: z.string(),
  plural: z.string(),
});

export const StockHistoryPointSchema = z.object({
  value: z.number(),
  changedAt: z.coerce.date(),
});

export type StockHistoryPoint = z.infer<typeof StockHistoryPointSchema>;

export const ItemSchema = z.object({
  id: z.number(),
  name: z.string(),
  price: z.number().nullable(),
  stock: z.number(),
  itemId: z.number(),
  customerId: z.number(),
  unitsInUOO: z.number(),
  unitOfOrder: z.string(),
  unitOfMeasure: z.string(),
  restockQuantity: z.number(),
  unitOfOrderForms: wordForms,
  unitOfMeasureForms: wordForms,
  invoiceDescription: z.string(),
  freeQty: z.number().optional(),
  imagePath: z.string().nullable(),
  minimalOrderQuantity: z.number(),
  customerReserve: z.number().optional(),
  stockHistory: z.array(StockHistoryPointSchema).optional(),
  customerReserveActiveTo: z.coerce.date().nullable().optional(),
});

export type Item = z.infer<typeof ItemSchema>;

interface ItemFactory {
  createFromName: (name: string, rest?: Partial<Item>) => Item;
}

const UNKNOWN_ITEM_ID = -1;
const DEFAULT_UOO = "pcs";
export const DEFAULT_UNIT_OF_MEASURE = "pcs";

export const itemFactory = (): ItemFactory => {
  return {
    createFromName: (name, rest) => {
      return {
        id: 0,
        name,
        stock: 0,
        price: 0,
        customerId: 0,
        unitsInUOO: 1,
        imagePath: null,
        restockQuantity: 0,
        unitOfMeasure: DEFAULT_UNIT_OF_MEASURE,
        unitOfOrder: DEFAULT_UOO,
        itemId: UNKNOWN_ITEM_ID,
        minimalOrderQuantity: 1,
        invoiceDescription: "",
        unitOfMeasureForms: {
          singular: "pc",
          plural: "pcs",
        },
        unitOfOrderForms: {
          singular: "bundle",
          plural: "bundles",
        },
        ...rest,
      };
    },
  };
};
